import { USER_GROUP_KEY } from '@loc/helpers/src/userGroup'

import { getCookies } from '@/helpers/cookies.browser'

export function getCookieUserGroup() {
  const cookies = getCookies()

  const data = cookies[USER_GROUP_KEY]
  return data || ''
}
